export enum CalendarView {
  CALENDAR,
  MONTHS,
  YEARS,
}

export enum CalendarRole {
  FROM,
  TO,
}

export enum WarningType {
  PAST_DATE = 'pastDate',
}
